module.exports = __webpack_public_path__ + "static/media/ic_show_alerts_hover.279b0086.svg";